<template>
    <div class="feedback-step question--yes-no">
        <!-- <div class="heading-third--grey ">{{ feedbackData.text }}</div> -->
        <div class="heading-third--pink ">{{ feedbackData.text }}</div>

        <div class="scale-buttons__stars">
            <span class="button-ths button-ths--link-pink" :class="[{'selected': scale === 1}]" @click="selectScale(1)">{{ feedbackData.options['tags'][0] }}</span>
            <span class="button-ths button-ths--link-pink" :class="[{'selected': scale === 2}]" @click="selectScale(2)">{{ feedbackData.options['tags'][1] }}</span>
            <span class="button-ths button-ths--link-pink" :class="[{'selected': scale === 3}]" @click="selectScale(3)">{{ feedbackData.options['tags'][2] }}</span>
            <span class="button-ths button-ths--link-pink" :class="[{'selected': scale === 4}]" @click="selectScale(4)">{{ feedbackData.options['tags'][3] }}</span>
            <span class="button-ths button-ths--link-pink" :class="[{'selected': scale === 5}]" @click="selectScale(5)">{{ feedbackData.options['tags'][4] }}</span>
        </div>

        <!-- <div v-for="(tag, index) in feedbackData.options['tags']"
            :key="index"
            class="scale-buttons__stars"
        >
            <span class="button-ths button-ths--link-pink" :class="[{'selected': scale === index + 1}]" @click="selectScale(index + 1)">{{ tag }}</span>
        </div> -->
    </div>
</template>

<script>
    export default {
        name: "StepScale",
        props: {
            feedbackData: {
                required: true,
                type: Object,
            },
            savedAnswer: {
                required: true,
            },
            surveyPassingId: {}
        },
        data() {
            return {
                scale: '',
                showFeedback: false,
            }
        },
        methods: {
            selectScale(i) {
                if (i === this.scale) {
                    this.scale = '';
                    this.$emit('updateProgress', false);
                }
                else {
                    this.scale = i;
                    this.$emit('updateProgress', true)
                }
                this.$emit('hideError')
            }
        },
        mounted() {
            if (this.savedAnswer) {
                this.scale = this.savedAnswer.value;
                this.$emit('updateProgress', true);
                //console.log("updateProgress true")
            }
            else {
                this.$emit('updateProgress', false);
                //console.log("updateProgress false")
            }
        },
        computed: {
            questionCopy() {
                return 'question.' + this.feedbackData.id
            },
            stepResult() {
                let stepResult = {
                    answer_data: JSON.stringify({value: this.scale}),
                    question_id: this.feedbackData.id,
                };
                if (this.surveyPassingId) {
                    this._lodash.assign(stepResult, {survey_passing_id: this.surveyPassingId});
                }
                return stepResult
            },
            canContinue() {
                return (this.scale === '') ? 0 : 1 ;
            },
            feedbackDataId() {
                return this.feedbackData && this.feedbackData.id;
            },
        },
        watch: {
            savedAnswer() {
                if (this.savedAnswer) {
                    this.scale = this.savedAnswer.value;
                    if (this.scale)
                        this.$emit('showFeedback', this.scale)
                }
                else {
                    this.scale = ''
                }
            },
            feedbackDataId() {
                if (!this.savedAnswer) {
                    this.scale = '';
                }
            }
        },
    }
</script>

<style scoped>

</style>
